// CSS Modules - component class name prefix: HeroSlider__

<template>
  <div :class="[{ HeroSlider__heightFirst: heightFirst }, $style.container]">
    <agile
      v-if="isActive"
      :dots="slides && slides.length > 1"
      :navButtons="slides && slides.length > 1"
      :fade="true"
      :speed="500"
      :autoplay="true"
      :autoplaySpeed="7000"
    >
      <figure
        :class="$style.slide"
        v-for="(slide, index) in slides"
        :key="`${slide.text}_${index}`"
      >
        <a :href="slide.url" :target="slide.newWindow ? '_blank' : '_self'">
          <div
            v-if="heightFirst"
            :class="$style.bgImage"
            :style="{ backgroundImage: `url(${slide.image})` }"
          >
            <img :src="slide.image" :alt="slide.title" />
          </div>
          <img
            v-else
            :src="slide.image"
            :alt="slide.title"
            :width="slide.imageWidth"
            :height="slide.imageHeight"
          />
          <figcaption
            v-if="slide.title || slide.text"
            :class="[
              { HeroSlider__caption__top: slide.captionTop },
              { HeroSlider__caption__left: slide.captionLeft },
              $style.caption
            ]"
          >
            <h1 v-if="index === 0" v-html="slide.title"></h1>
            <h3 v-else v-html="slide.title"></h3>
            <div :class="$style.captionText" v-html="slide.text"></div>
          </figcaption>
        </a>
      </figure>
      <template slot="prevButton">
        <ChevronLeft />
      </template>
      <template slot="nextButton">
        <ChevronRight />
      </template>
    </agile>
  </div>
</template>

<script>
import { VueAgile } from "../vue-agile";
import { isIE } from "mobile-device-detect";
import ChevronLeft from "../../assets/svg/ChevronLeft.vue";
import ChevronRight from "../../assets/svg/ChevronRight.vue";

export default {
  name: "HeroSlider",
  components: {
    agile: VueAgile,
    ChevronLeft,
    ChevronRight
  },
  props: {
    slides: {
      type: Array,
      default: () => []
    },
    heightFirst: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActive: false
    };
  },
  mounted() {
    if (isIE) {
      setTimeout(() => {
        this.isActive = true;
      }, 500);
    } else {
      this.isActive = true;
    }
  }
};
</script>

<style module lang="scss">
@import "./HeroSlider.scss";
</style>
